class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    document.addEventListener('cart-drawer-updated', this.open.bind(this));
    this.cartUpdatingUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdating, this.handleCartUpdating.bind(this));
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
    if (window.location.hash.includes('#cart')) {
      this.open();
    }
    document.addEventListener("fg-cart:auto-updated", this.handleFreeGiftUpdate.bind(this));
  }

  handleFreeGiftUpdate(event) {
    publish(PUB_SUB_EVENTS.cartUpdating, {
      source: 'cart-items',
    })
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: event.detail });
  }



  disconnectedCallback() {
    if (this.cartUpdatingUnsubscriber) {
      this.cartUpdatingUnsubscriber();
    }
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  handleCartUpdating() {
    this.classList.add('td-cart-drawer--loading');
  }

  handleCartUpdate() {
    this.classList.remove('td-cart-drawer--loading');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#td-cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    const closeMenuEvent = new CustomEvent('close-menu', {
      bubbles: true,
      cancelable: true,
      detail: { source: 'cart-drawer' },
    });
    document.dispatchEvent(closeMenuEvent);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  openCartDrawer() {
    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const htmlElement = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return htmlElement.innerHTML;
  }


  getSectionsToRender() {
    return [
      {
        id: 'td-CartDrawer',
        section: 'td-cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'td-cart-icon-bubble',
        section: 'td-cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items') || this.closest('td-drawer cart-items');
      this.closest('.td-cart-drawer__item, .td-cart-drawer__item-byo, .td-cart-drawer__gift-card-item').classList.add('td-cart-drawer__item--loading');
      if (this.dataset.byo) {
        cartItems.updateQuantityByo(this.dataset.index, 0, event, null, null, this.dataset.key);
      } else if (this.dataset.syog) {
        const syogItems = this.closest('.td-cart-drawer__gift-wrapper').querySelectorAll('[data-syog]')
        const keys = []
        Array.from(syogItems).forEach((item) => {
          keys.push(item.dataset.key);
          item.closest('.td-cart-drawer__gift-card-item').classList.add('td-cart-drawer__item--loading');
        });
        cartItems.removeLinesFromCart(keys);
      } else {
        cartItems.updateQuantity(this.dataset.index, 0, event, null, null, this.dataset.key);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);



class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = this.debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
    document.addEventListener('td:clear-cart', this.handleClearCart.bind(this));
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    const key = event.target.dataset.key;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      if (event.target.dataset.byo) {
        this.updateQuantityByo(index, inputValue, event, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId, key);
      } else {
        this.updateQuantity(index, inputValue, event, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId, key);
      }
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      const sections = this.getSectionsToRender();
      return fetch(`${routes.cart_url}?sections=${sections.map((section) => section.section).join(',')}`)
        .then((response) => response.json())
        .then((response) => {
          this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);
              this.updateInnerHTML(elementToReplace, response[section.section], section.selector);
          });
          document.dispatchEvent(new CustomEvent('cart-drawer-updated'));
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          document.dispatchEvent(new CustomEvent('cart-drawer-updated'));
        })
        .catch((e) => {
          console.error(e);
        });
    }

  }

  getSectionsToRender() {
    return [
      {
        id: 'td-CartDrawer',
        section: 'td-cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'td-cart-icon-bubble',
        section: 'td-cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }


  updateQuantity(line, quantity, event, name, variantId, key) {
    this.enableLoading(line);

    const body = JSON.stringify({
      id: key,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    publish(PUB_SUB_EVENTS.cartUpdating, {
      source: 'cart-items',
    })
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            this.updateInnerHTML(elementToReplace, parsedState.sections[section.section], section.selector);
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          // if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          //   if (typeof updatedValue === 'undefined') {
          //     message = window.cartStrings.error;
          //   } else {
          //     message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          //   }
          // }


          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        


        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((e) => {
        console.error(e);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
  }

  updateQuantityByo(line, quantity, event, name, variantId, key) {
    const minQuantity = parseInt(this.dataset.byoMinQuantity);
    const byoItems = this.querySelectorAll('input[data-byo]');
    const count = Array.from(byoItems).reduce((acc, item) => key != item.dataset.key ? acc + parseInt(item.value) : acc, 0) + parseInt(quantity);
    const lines = Array.from(byoItems).map((item) => item.dataset.key);
    if (count < minQuantity) {
      this.removeLinesFromCart(lines);
    } else {
      this.updateQuantity(line, quantity, event, name, variantId, key);
    }
  }

  handleClearCart() {
    return fetch(`${routes.cart_clear_url}`)
        .then((response) => response.text())
        .then((response) => {
          window.location.reload();
        })
        .catch((e) => {
          console.error(e);
        });    
  }

  removeLinesFromCart(lines) {
    const updates = {}
    if (lines && lines.length > 0) {
      lines.forEach((line) => {
        updates[line] = 0;
      })
    }
    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
    });
    publish(PUB_SUB_EVENTS.cartUpdating, {
      source: 'cart-items',
    })
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

          if (parsedState.errors) {
            console.error(parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            this.updateInnerHTML(elementToReplace, parsedState.sections[section.section], section.selector);
          });


        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
      })
      .catch((e) => {
        console.error(e);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  updateInnerHTML(elementToReplace, html, selector) {

    const newHtml = this.getSectionHTML(html, selector);
    this.maybeModifyCartRecommendations(elementToReplace, newHtml);
    this.maybeUpdateProgressBar(elementToReplace, newHtml);
    elementToReplace.innerHTML = newHtml.innerHTML;
  }
  maybeModifyCartRecommendations(elementToReplace, newHtml) {
    const cartRecommendations = newHtml.querySelector('cart-recommendations');
    const existingCartRecommendations = elementToReplace.querySelector('cart-recommendations');
    if (cartRecommendations && existingCartRecommendations && cartRecommendations.dataset.url === existingCartRecommendations.dataset.url) {
      existingCartRecommendations.dataset.preventReInit = true;
      cartRecommendations.replaceWith(existingCartRecommendations);
    }
  }

  maybeUpdateProgressBar(elementToReplace, newHtml) {
    const newProgressBar = newHtml.querySelector('td-cart-progress-bar');
    const existingProgressBar = elementToReplace.querySelector('td-cart-progress-bar');
    if (newProgressBar && existingProgressBar) {
      newProgressBar.dataset.oldProgress = existingProgressBar.dataset.progress;
      newProgressBar.dataset.oldCartAmount = existingProgressBar.dataset.cartAmount;
      newProgressBar.style.setProperty('--previous-progress', `${existingProgressBar.dataset.progress}%`);
    }
  }
 
  getSectionHTML(html, selector) {
    const htmlElemnt = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return htmlElemnt;
  }

  getSectionInnerHTML(html, selector) {
    const htmlElemnt = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return htmlElemnt.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'td-CartDrawer',
        section: 'td-cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'td-cart-icon-bubble',
        section: 'td-cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


const cartTrapFocusHandlers = {};

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', cartTrapFocusHandlers.focusin);
  document.removeEventListener('focusout', cartTrapFocusHandlers.focusout);
  document.removeEventListener('keydown', cartTrapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  cartTrapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', cartTrapFocusHandlers.keydown);
  };

  cartTrapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', cartTrapFocusHandlers.keydown);
  };

  cartTrapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', cartTrapFocusHandlers.focusout);
  document.addEventListener('focusin', cartTrapFocusHandlers.focusin);

  elementToFocus?.focus();

  if (
    elementToFocus?.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus?.type) &&
    elementToFocus?.value
  ) {
    elementToFocus?.setSelectionRange(0, elementToFocus?.value.length);
  }
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    this.closest('.td-cart-drawer__item, .td-cart-drawer__item-byo').classList.add('td-cart-drawer__item--loading');
    if (event.target.name === 'plus' || event.target.closest('button[name="plus"]')) {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}